type UserYobelyInfoCardProps = {
  createUser: boolean;
  broadcastGroupName: string;
  handleBroadcastGroupModalClick: () => void;
};

export const UserYobelyInfoCard = ({
  createUser,
  broadcastGroupName,
  handleBroadcastGroupModalClick,
}: UserYobelyInfoCardProps) => {
  return (
    <div>
      <h2 className="mb-5 label-light-blue-xl">
        {" "}
        一斉発信グループ <span className="text-red-500">*</span>
      </h2>

      <div>
        <div className="flex items-center gap-2.5">
          <input
            type="text"
            className="form-field-text whitespace-nowrap w-1/4"
            value={broadcastGroupName || "未登録"}
            readOnly
          />
          {(createUser || !broadcastGroupName) && (
            <div
              className="button-default-white"
              onClick={handleBroadcastGroupModalClick}
            >
              グループ選択
            </div>
          )}
        </div>

        <div className="mt-5 divider"></div>
      </div>
    </div>
  );
};
